'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');
var Typography$1 = require('../../../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    eyebrow: _objectSpread({}, theme.typography.eyebrow)
  };
});
var V2_VARIANT_MAP = {
  h4: 'h1',
  h5: 'h2',
  h6: 'h3'
};

var Typography = function Typography(_ref) {
  var variant = _ref.variant,
      component = _ref.component,
      className = _ref.className,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '' : _ref$version,
      rest = objectWithoutProperties(_ref, ["variant", "component", "className", "version"]);

  var _useStyles = useStyles(),
      eyebrow = _useStyles.eyebrow;

  var mapV2Variant = function mapV2Variant(variant) {
    return V2_VARIANT_MAP[variant] || variant;
  };

  var typographyVariant = version === 'v2' ? mapV2Variant(variant) : variant;

  if (variant === 'caption') {
    return React__default["default"].createElement(Typography$1["default"], _objectSpread({
      variant: variant,
      component: component || "div",
      className: className
    }, rest));
  }

  if (variant === 'eyebrow') {
    return React__default["default"].createElement(Typography$1["default"], _objectSpread({
      component: component || 'div',
      className: classNames__default["default"](eyebrow, className)
    }, rest));
  }

  return React__default["default"].createElement(Typography$1["default"], _objectSpread({
    variant: typographyVariant,
    className: className,
    component: component
  }, rest));
};

module.exports = Typography;
